import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/hooks/useAuth";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminRoute } from "@/components/auth/AdminRoute";
import { HelpButton } from "@/components/support/HelpButton";
import { InstallPrompt } from "@/components/pwa";
import Index from "./pages/Index";
import Funcionalidades from "./pages/Funcionalidades";
import Precos from "./pages/Precos";
import Sobre from "./pages/Sobre";
import Suporte from "./pages/Suporte";
import Login from "./pages/Login";
import Cadastro from "./pages/Cadastro";
import RecuperarSenha from "./pages/RecuperarSenha";
import RedefinirSenha from "./pages/RedefinirSenha";
import Termos from "./pages/Termos";
import Privacidade from "./pages/Privacidade";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/dashboard/Dashboard";
import NovaTask from "./pages/dashboard/NovaTask";
import TaskDetails from "./pages/dashboard/TaskDetails";
import Creditos from "./pages/dashboard/Creditos";
import Configuracoes from "./pages/dashboard/Configuracoes";
import Tasks from "./pages/dashboard/Tasks";
import AdminDashboard from "./pages/admin/AdminDashboard";
import DesignSystemTest from "./pages/DesignSystemTest";
import Splash from "./pages/Splash";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AuthProvider>
          <Toaster />
          <Sonner />
          <InstallPrompt />
          <BrowserRouter>
            <HelpButton />
            <Routes>
              <Route path="/splash" element={<Splash />} />
              <Route path="/" element={<Index />} />
              <Route path="/funcionalidades" element={<Funcionalidades />} />
              <Route path="/precos" element={<Precos />} />
              <Route path="/sobre" element={<Sobre />} />
              <Route path="/suporte" element={<Suporte />} />
              <Route path="/login" element={<Login />} />
              <Route path="/cadastro" element={<Cadastro />} />
              <Route path="/recuperar-senha" element={<RecuperarSenha />} />
              <Route path="/redefinir-senha" element={<RedefinirSenha />} />
              <Route path="/termos" element={<Termos />} />
              <Route path="/privacidade" element={<Privacidade />} />

              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/dashboard/nova-task" element={
                <ProtectedRoute>
                  <NovaTask />
                </ProtectedRoute>
              } />
              <Route path="/dashboard/task/:id" element={
                <ProtectedRoute>
                  <TaskDetails />
                </ProtectedRoute>
              } />
              <Route path="/dashboard/creditos" element={
                <ProtectedRoute>
                  <Creditos />
                </ProtectedRoute>
              } />
              <Route path="/dashboard/tasks" element={
                <ProtectedRoute>
                  <Tasks />
                </ProtectedRoute>
              } />
              <Route path="/dashboard/configuracoes" element={
                <ProtectedRoute>
                  <Configuracoes />
                </ProtectedRoute>
              } />
              <Route path="/dashboard/vault" element={
                <ProtectedRoute>
                  <Tasks />
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              } />
              <Route path="/ds-test" element={
                <AdminRoute>
                  <DesignSystemTest />
                </AdminRoute>
              } />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
